import Flickity from "flickity";
import "flickity-fade";

export function initSlideshows() {
  const slideshows = document.querySelectorAll(".js-slideshow");
  for (const slideshow of slideshows) {
    const prevArrow = slideshow.querySelector(".js-slideshow-prev");
    const nextArrow = slideshow.querySelector(".js-slideshow-next");
    const slides = slideshow.querySelector(".js-slideshow-slides");
    const flckty = new Flickity(slides, {
      fade: true,
      draggable: false,
      pageDots: false,
      wrapAround: true,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      resize: true,
      autoPlay: 3000,
    });

    prevArrow.addEventListener("click", () => {
      flckty.pausePlayer();
      flckty.previous();
      flckty.resize();
    });
    nextArrow.addEventListener("click", () => {
      flckty.pausePlayer();
      flckty.next();
      flckty.resize();
    });
  }
}
